import "./LayoutWizardMetadataGroup.scss";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import * as layoutWizardHelper from "@/helpers/layoutWizardHelper";
import { Drag, Drop, DropList } from "vue-easy-dnd";
import VJsoneditor from "v-jsoneditor";
import LayoutWizardMetaItemListDialog from "@/components/LayoutWizard/LayoutWizardMetaItemListDialog/LayoutWizardMetaItemListDialog.vue";

export default {
  name: "LayoutWizardMetadataGroup",
  components: {
    Drag,
    Drop,
    DropList,
    VJsoneditor,
    LayoutWizardMetaItemListDialog
  },
  data: () => ({
    mainPeacock: "#00636C",
    isRequired: [v => !!v || "Feld bitte ausfüllen"],
    metaItems: [],
    metaItemsGroup: {},
    metaItemDialog: false,
    groupModal: false,
    groupSample: {
      title: {
        label: "Titel",
        form: "input",
        required: true
      },
      description: {
        label: "Beschreibung",
        form: "textarea",
        required: false
      },
      discount: {
        label: "Rabatt",
        form: "input",
        required: true,
        type: "number"
      }
    },

    groupItem: {},
    code_options: { mode: "code" }
  }),
  props: ["metadataGroups"],
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    }
  },
  methods: {
    ...layoutWizardHelper,
    jsonEditorError(value) {
      console.error("jsonEditorError:", value);
    },
    async createGroup() {
      try {
        this.groupItem.principal_id = this.currentPrincipal;
        this.groupItem.sort_key = this.metadataGroups.length + 1;
        const headers = getTokenHeader(),
          res = await axios.post(
            `${env.assistent_api_client_url}metadata_groups`,
            this.groupItem,
            { headers }
          );
        this.metadataGroups.push(res.data);
        this.groupModal = false;
      } catch (error) {
        this.createError(error);
      }
    },
    async updateGroup() {
      try {
        const headers = getTokenHeader();
        await axios.put(
          `${env.assistent_api_client_url}metadata_groups/${this.groupItem.key}?principal_id=${this.groupItem.principal_id}`,
          this.groupItem,
          { headers }
        );
        this.groupModal = false;
        this.$emit("loadMetadataGroups");
      } catch (error) {
        this.createError(error);
      }
    },
    async deleteGroup(item) {
      this.$confirm(
        `Sind Sie sicher, dass Sie 
        <br>"${item.title}" löschen wollen?`,
        confirmWarningConfig
      ).then(async res => {
        if (res) {
          try {
            const headers = getTokenHeader();
            await axios.delete(
              `${env.assistent_api_client_url}metadata_groups/${item.key}?principal_id=${item.principal_id}`,
              { headers }
            );
            this.$emit("loadMetadataGroups");
          } catch (err) {
            this.createError(err);
          }
        }
      });
    },
    reorderGroups() {
      let count = 0;
      this.metadataGroups.map(async item => {
        item.sort_key = count++;
        try {
          const headers = getTokenHeader();
          await axios.put(
            `${env.assistent_api_client_url}metadata_groups/${item.key}?principal_id=${item.principal_id}`,
            { sort_key: item.sort_key },
            { headers }
          );
        } catch (error) {
          this.createError(error);
        }
      });
    },
    emptyGroupDialog() {
      this.groupModal = true;
      this.groupItem = {};
      this.groupItem.fields = {};
    },
    editGroup(item) {
      this.groupModal = true;
      this.groupItem = Object.assign({}, item);
    },
    insertGroup(event) {
      this.metadataGroups.splice(event.index, 0, event.data);
    },
    async listGroupItems(group) {
      this.metaItems = await this.getMetaGroup(group.key);

      this.metaItemsGroup = group;
      this.metaItemDialog = true;
    },
    async getMetaGroup(id) {
      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal,
        by_group_id: id
      };
      try {
        const response = await axios.get(
          env.assistent_api_client_url + "metadata",
          {
            headers,
            params
          }
        );
        return response.data;
      } catch (error) {
        this.createError(error);
      }
    },
    afterSaveMetaItemDialog(close) {
      if (close) {
        this.metaItemDialog = false;
      }
      this.snackMessage("Erfolgreich gespeichert!");
    }
  }
};
